import MangaCard from '@/components/base/MangaCard';
import { getLatestManga } from '@/mocks/manga';

export default function LatestUpdate() {
  const latestManga = getLatestManga(12);

  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">热门漫画每日更新，追更不停歇</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
          </span>
          <span className="text-xs text-foreground-500">实时更新中</span>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
        {latestManga.map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>
    </section>
  );
}